<template>
  <div class="table-content row-data">
    <!-- chi tiết khoản các học sinh -->
    <el-table
        element-loading-spinner="el-icon-loading"
        :empty-text="textTable"
        :data="responseFilterList"
        v-loading="loadingData"
        :element-loading-text="$tableLoading"
        element-loading-background="rgba(255,255,255, 0)"
        :header-cell-style="tableHeaderColor"
        @selection-change="handleSelectionChange"
        :max-height="$tableMaxHeight"
        border
        :summary-method="getSummaries"
        show-summary
    >
      <el-table-column
          type="selection"
          align="center"
          width="55"
      ></el-table-column>
      <el-table-column
          type="index"
          fixed="left"
          label="STT"
          width="50"
          align="center"
      ></el-table-column>

      <el-table-column width="150" fixed="left" label="Họ tên">
        <template v-slot:default="scope">
          <el-tooltip placement="top">
            <div slot="content">Mã học sinh: {{ scope.row.kidCode }}<br>Bố/Mẹ: {{ scope.row.fatherPhone }} -
              {{ scope.row.motherPhone }}
            </div>
            <span>{{ scope.row.fullName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column width="90" label="Biệt danh" align="center">
        <template v-slot:default="scope">
          <span>{{ scope.row.nickName }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" width="70" label="Hiển thị">
        <template v-slot:default="scope">
          <el-checkbox
              v-model="scope.row.orderHidden"
              @change="handelShowOrHidden(scope.row)"
              :disabled="
              scope.row.status === null || scope.row.status === 'Ẩn hóa đơn'
            "
          ></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column label="Thông tin bổ sung" align="center" width="90">
        <template v-slot:default="scope">
          <el-button
              size="mini"
              @click="handleOpenKidDetail(scope.row, scope.row.status)"
          ><i class="el-icon-document"></i
          ></el-button>
        </template>
      </el-table-column>

      <el-table-column align="center" width="75" label="Tháng tồn">
        <template v-slot:default="scope">
          <el-button
              class="click-in-row"
              type="text"
              @click="inventoryOrder(scope.row)"
              v-if="scope.row.count !== 0"
          >{{ scope.row.count }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column align="center" width="110" label="Trạng thái">
        <template v-slot:default="scope">
          <div :class="getStatusColor(scope.row.status)">
            {{ getStatusValue(scope.row.status) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column align="center" width="110" label="Chuyển thanh toán">
        <template v-slot:default="scope">
          <span v-if="scope.row.transactionEntry==='MONEY_WALLET'&& scope.row.afterMoney !==0" style="color: orange ">Không chuyển</span>
          <span v-if="scope.row.transactionEntry==='MONEY_MONTH'&& scope.row.afterMoney !==0" style="color: blue ">Sang tháng sau</span>
        </template>
      </el-table-column>

      <el-table-column
          align="right"
          width="120"
          label="Thiếu/Thừa tháng trước"
          prop="beforeMoney"
      >
        <template v-slot:default="scope">
          {{ scope.row.beforeMoney | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column align="right" width="120" label="Phải thu tháng này" prop="sumMoney">
        <template v-slot:default="scope">
          {{ scope.row.sumMoney | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column align="right" width="120" label="Đã thu" prop="collectedMoney">
        <template v-slot:default="scope">
          <el-button
              
              v-if="getStatusValue(scope.row.status) !=='Chưa có hóa đơn'"
              class="click-in-row"
              type="text"
              @click="collectedMoneyMethod(scope.row, scope.row.status)">
            <span v-if="scope.row.collectedMoney">{{ scope.row.collectedMoney | formatCurrency }}</span>
            <span v-else><b>-</b></span>
          </el-button>
        </template>
      </el-table-column>

      <el-table-column align="right" width="120" label="Tiền mặt" prop="cashMoney">
        <template v-slot:default="scope">
          {{ scope.row.cashMoney | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column align="right" width="120" label="Chuyển khoản" prop="transferMoney">
        <template v-slot:default="scope">
          {{ scope.row.transferMoney | formatCurrency }}
        </template>
      </el-table-column>
      <el-table-column align="right" width="120" label="Thiếu / Thừa còn lại" prop="afterMoney">
        <template v-slot:default="scope">
          {{ scope.row.afterMoney | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column
          v-for="column in dynamicRevenueColumns"
          :key="column.prop"
          align="right"
          width="115"
          :label="column.label"
          :prop="column.prop"
      >
        <template #header="scope">
          <el-tooltip :content="scope.column.label" placement="top">
            <span @click="changeNameRevenus(column.label)" style="cursor: pointer;">{{ column.label }}</span>
          </el-tooltip>
        </template>
        <template v-slot:default="scope">
          <el-button
              v-if="getStatusValue(scope.row.status) !=='Chưa có hóa đơn'"
              class="click-in-row"
              type="text"
              @click="getDetailKT(scope.row, scope.column.label, scope.row.status)"
          >
            <span v-if="scope.row[column.prop]"> {{ scope.row[column.prop] | formatCurrency }}</span>
            <span v-else>-</span>
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="Tác vụ" fixed="right" align="center" :width="responseFilterList.length <= 10 ? '215px' : '198px'">
        <template v-slot:default="scope">
          <div style="display: inline-flex">
            <el-button style="display: none"></el-button>
            <!--           giữ nút này do lỗi framework k cập nhật, check được :disable(thanh toán) khi render giao diện-->
            <el-button
                v-if="checkPermission(['fees_2_excel_cash_payment'])"
                size="mini"
                :type="getButtonCashierType(scope.row)"
                @click="orderKidsCashierMethod(scope.row)"
                :disabled="scope.row.status === null || scope.row.status === 'Ẩn hóa đơn'|| scope.row.sumMoney === 0 || scope.row.onlinePaymentSuccessful === true"
            >Thanh toán
            </el-button>

            <el-button
                type="success"
                size="mini"
                @click="orderKidsHistoryMethod(scope.row)"
                :disabled="
              scope.row.status === null|| scope.row.sumMoney === 0
            "
            >
              Lịch sử
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <HistoryOrderKidsDialog
        :isOpenHistoryDialog="showHistoryDialog"
        @closeHistoryOrderKids="closeOrderKidsHistoryDialog()"
        ref="OrderKidsHistoryDialog"
    />
    <ExcelKidDetail
        :isOpenKidDetail="isOpenKidDetailDialog"
        :kids-detail-data="kidDetailData"
        @closeDetailKid="handleCloseDetailKid"
        ref="ExcelKidDetail"
    />

    <OrderKidsExcelCashier
        :isOpenCashierDialog="showOrderKidsExcelCashierDialog"
        @dialog-close="closeOrderKidsExcelCashierDialog"
        :isActivatedAccount="isActivatedAccount"
        ref="OrderKidsExcelCashier"
    />

    <CollectedMoneyDialog
        v-if="checkPermission(['fees_2_excel_cash_payment'])"
        :isOpenCollectedMoney="showCollectedMoney"
        @closeCollectedMoney="closeCollectedMoneyDialog()"
        ref="CollectedMoneyDialog"
    />

    <InventoryOrderDialog
        :isOpenInventoryOrder="showInventoryOrder"
        @closeInventoryOrder="closeInventoryOrderDialog()"
        ref="InventoryOrderDialog"
    />

    <DetailKTDialog
        :isOpenDetailKT="detailKT"
        @closeDetailKT="closeDetailKTDialog"
        ref="DetailKTDialog"
    />

    <ChangeNameRevenusDialog
        v-if="checkPermission(['fees_2_excel_cash_payment'])"
        :isOpenChangeNameRevenusDialog="modifierLesRevenus"
        :nameRevenus="nameRevenus"
        :checkDelete="checkDelete"
        @closeChangeNameRevenusDialog="closeChangeNameRevenusDialog"
    />

  </div>
</template>
<script>
import ExcelKidDetail from "@/components/FinanceVer2/ByClass/ExcelTableDialog/ExcelKidDetailDialog.vue";
import {mapState} from "vuex";
import HistoryOrderKidsDialog from "@/components/FinanceVer2/ByClass/ExcelTableDialog/HistoryOrderKidsDialog.vue";
import OrderKidsExcelCashier from "@/components/FinanceVer2/ByClass/ExcelTableDialog/OrderKidsExcelCashier.vue";
import CollectedMoneyDialog from "@/components/FinanceVer2/ByClass/ExcelTableDialog/CollectedMoneyDialog.vue";
import InventoryOrderDialog from "@/components/FinanceVer2/ByClass/ExcelTableDialog/InventoryOrderDialog.vue";
import DetailKTDialog from "@/components/FinanceVer2/ByClass/ExcelTableDialog/DetailKTDialog.vue";
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import tableValidateMixin from "@/global/mixin/tableValidate.mixin";
import countColumnActionMixin from "@/global/mixin/countColumnAction.mixin";
import ChangeNameRevenusDialog from "@/components/FinanceVer2/ByClass/TableSearchDialog/ChangeNameRevenusDialog.vue";
import checkPermission from "@/utils/permission";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "KidsExcelTable",
  components: {
    ChangeNameRevenusDialog,
    DetailKTDialog,
    InventoryOrderDialog,
    CollectedMoneyDialog,
    HistoryOrderKidsDialog,
    ExcelKidDetail,
    OrderKidsExcelCashier,
  },
  computed: {
    ...mapState("finance2Module", [
      "responseFilterList",
      "loadingData",
      "listKT",
      "dataSearch", "checkResponse"
    ]),
    dynamicRevenueColumns() {
      const listKT = this.listKT || {};
      return Array.from({length: 20}, (_, index) => {
        const number = index + 1;
        const defaultLabel = `Khoản thu ${number}`;
        const label = listKT[`nameKt${number}`] || defaultLabel;
        return {
          number,
          label,
          prop: `moneyKt${number}`,
          isDefault: label === defaultLabel,
        };
      }).filter(column => !column.isDefault);
    },
  },
  mixins: [tableValidateMixin, countColumnActionMixin],
  data() {
    return {
      // Hiển thị/ Bỏ hiển thị Hóa đơn
      showOrHidden: {
        date: "",
        idKid: "",
        collectionTurn: "",
        status: false,
      },
      // dialog field
      kidDetailData: {},
      isOpenKidDetailDialog: false,
      showHistoryDialog: false,
      showOrderKidsExcelCashierDialog: false,
      multipleSelection: [],
      textTable: this.$tableEmpty,
      showCollectedMoney: false,
      showInventoryOrder: false,
      detailKT: false,
      modifierLesRevenus: false,
      nameRevenus: "",
      checkDelete: true,
      isActivatedAccount: false,
    };
  },
  watch: {
    checkResponse() {
      if (this.checkResponse === false) {
        this.textTable = this.$tableEmpty
      }
    },
  },

  methods: {
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 8) {
          sums[index] = "Tổng cộng";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0).toLocaleString("vi-VN", {
            style: "currency",
            currency: "VND"
          });
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    checkPermission,
    getButtonCashierType(row) {
      if (row.status === "Đóng đủ 100%" || row.status === "Đóng đủ thừa" || row.status === "Đóng đủ thiếu") {
        return 'info';
      }
      return 'primary';
    },
    changeNameRevenus(name) {
      this.checkDelete = true
      this.modifierLesRevenus = true;
      this.nameRevenus = name;
      const lastRevenueColumn = this.dynamicRevenueColumns[this.dynamicRevenueColumns.length - 1];
      if (lastRevenueColumn && name === lastRevenueColumn.label) {
        this.checkDelete = false
      }
    },
    handelShowOrHidden(row) {
      this.$confirm(
          `
            ⚠️ <strong>Bạn có chắc chắn muốn ${row.orderHidden ? 'hiện' : 'ẩn'} hóa đơn này không?</strong><br><br>
            Vui lòng kiểm tra kỹ thông tin hóa đơn trước khi thực hiện:<br>
            👉 Bạn muốn tiếp tục?
            `,
          "Xác nhận thay đổi trạng thái hóa đơn",
          {
            confirmButtonText: "Có, Tiếp tục",
            cancelButtonText: "Không",
            type: "warning",
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            distinguishCancelAndClose: true,
          }
      ).then(async () => {
        this.showOrHidden.date = this.$funcCommon.formatMY(this.dataSearch.createdYear, this.dataSearch.month);
        this.showOrHidden.idKid = row.id;
        this.showOrHidden.collectionTurn = this.dataSearch.collectionTurn;
        if (row.orderHidden) {
          this.showOrHidden.status = true;
          this.$store.commit("finance2Module/set_show_app_message", row.fullName);
        } else {
          this.showOrHidden.status = false
          this.$store.commit("finance2Module/set_hidden_app_message", row.fullName);

        }
        await financeKidsV2Service
            .showOrHiddenOrderKids(this.showOrHidden)
            .then((res) => {
              NotifyMessage.leftCornerNotificationSuccess(res.data.message)
            })
            .catch(() => {
              NotifyMessage.leftCornerNotificationError("Lỗi hệ thống!")
            });
      });

    },
    // dialog hiển thị thông tin điểm danh
    handleOpenKidDetail(row, statusOrder) {
      this.isOpenKidDetailDialog = true;
      this.$refs.ExcelKidDetail.getInfoByMonthAndTurn(
          this.dataSearch.month,
          row.id,
          this.dataSearch.collectionTurn,
          statusOrder,
          this.dataSearch.createdYear,
      );
    },
    handleCloseDetailKid(close) {
      this.isOpenKidDetailDialog = close;
      this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
    },
    closeChangeNameRevenusDialog(close) {
      this.modifierLesRevenus = close;
      this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
    },
    /**
     * Mở dialog lưu lịch sử thanh toán
     * @param row
     */
    orderKidsCashierMethod(row) {
      if (this.dataSearch.collectionTurn === 0) {
        this.$message({
          message: "Bạn chưa chọn đợt thu",
          type: "error",
        });
      } else {
        let idKid = row.id;
        let kidCode = row.kidCode;
        let kidName = row.fullName;
        let orderKidCode = row.orderKidCode;
        let month = this.dataSearch.month;
        let year = this.dataSearch.createdYear;

        let collectionTurn = this.dataSearch.collectionTurn;
        this.showOrderKidsExcelCashierDialog = true;
        this.$refs.OrderKidsExcelCashier.getDataCashierInitial(
            idKid,
            kidCode,
            kidName,
            month,
            collectionTurn,
            orderKidCode,
            year
        );
        this.isActivatedAccount = row.fatherPhone !== "" || row.motherPhone !== "";
      }
    },

    /**
     * Mở dialog hiển thị lịch sử thanh toán
     * @param row
     */
    orderKidsHistoryMethod(row) {
      this.showHistoryDialog = true;
      this.$refs.OrderKidsHistoryDialog.getOrderHistoryInitial(
          row.id,
          this.dataSearch.month,
          this.dataSearch.collectionTurn,
          this.dataSearch.createdYear
      );
    },

    closeOrderKidsHistoryDialog() {
      this.showHistoryDialog = false;
      // this.searchOrderKidsByProperties();
      this.$store.commit('finance2Module/get_status_excel')
    },

    /**
     * Mở dialog hiển thị tiền đã thu
     */
    collectedMoneyMethod(row, status) {
      if (row.onlinePaymentSuccessful === true){
        NotifyMessage.leftCornerNotificationWarning("Hóa đơn đã được thanh toán trực tuyến thành công lên không thể sửa đổi!")
      } else {
        this.showCollectedMoney = !this.showCollectedMoney;
        this.$refs.CollectedMoneyDialog.getCollectedMoney(
            this.dataSearch.month,
            row.id,
            this.dataSearch.collectionTurn,
            status,
            this.dataSearch.createdYear
        );
      }
    },

    closeCollectedMoneyDialog(boolean) {
      this.showCollectedMoney = boolean;
    },

    /**
     * Mở dialog hiển thị tồn hóa đơn
     */
    inventoryOrder(row) {
      this.showInventoryOrder = !this.showInventoryOrder;
      this.$refs.InventoryOrderDialog.getInventoryOrder(
          row.kidCode,
          row.fullName,
          row.id
      );
    },

    closeInventoryOrderDialog(boolean) {
      this.showInventoryOrder = boolean;
      this.$store.commit('finance2Module/get_status_excel')

    },

    /**
     * Mở dialog hiển thị chi tiết khoản thu
     */
    getDetailKT(row, nameKt, statusOrder) {
      if (row.onlinePaymentSuccessful === true){
        NotifyMessage.leftCornerNotificationWarning("Hóa đơn đã được thanh toán trực tuyến thành công lên không thể sửa đổi!")
      } else {
        this.detailKT = !this.detailKT;
        this.$refs.DetailKTDialog.showDetailKT(
            this.dataSearch.month,
            row.kidCode,
            this.dataSearch.collectionTurn,
            nameKt,
            statusOrder,
            this.dataSearch.createdYear
        );
      }

    },

    closeDetailKTDialog(boolean) {
      this.detailKT = boolean;
    },

    closeOrderKidsExcelCashierDialog() {
      this.showOrderKidsExcelCashierDialog = false;
      this.$store.commit('finance2Module/get_status_excel')
    },

    tableHeaderColor(column) {
      this.countNonEmptyAttributes(this.listKT)
      const index = column.columnIndex;
      const revenueStart = 15;
      const revenueEnd = 14 + this.countColumnAttributes;

      // Nhóm: Thông tin học sinh (selection -> tháng tồn)
      if (index >= 0 && index <= 6) {
        return "background-color: #3b8f86;color: #fff;font-weight: 600;";
      }
      // Nhóm: Trạng thái
      if (index >= 7 && index <= 8) {
        return "background-color: #8a7bc2;color: #fff;font-weight: 600;";
      }
      // Nhóm: Tài chính cố định
      if (index >= 9 && index <= 14) {
        return "background-color: #4f86c4;color: #fff;font-weight: 600;";
      }
      // Nhóm: Khoản thu động
      if (index >= revenueStart && index <= revenueEnd) {
        return "background-color: #c58b4a;color: #fff;font-weight: 600;";
      }
      // Nhóm: Tác vụ (fixed right)
      return "background-color: #5f9b67;color: #fff;font-weight: 600;";
    },
    // chọn nhiều truonwgf
    handleSelectionChange(val) {
      this.multipleSelection = val; // val laf 1 array object
      this.listNullBillKids = [];
      this.listHiddenOrder = []
      this.listShowForApp = []
      this.listHiddenForApp = []
      this.multipleSelection.forEach((row) => {
        if (this.validateNullBillStudent(row)) {
          this.listNullBillKids = [...this.listNullBillKids, row.fullName];
        }
        if (this.validateHiddenOrder(row)) {
          this.listHiddenOrder = [...this.listHiddenOrder, row.fullName]; // lấy danh sách bị ẩn
        }
        if (row.orderHidden) {
          this.listShowForApp = [...this.listShowForApp, row.fullName]// lấy danh sách hiển thị lên app
        }
        if (!row.orderHidden) {
          this.listHiddenForApp = [...this.listHiddenForApp, row.fullName]// lấy danh sách không hiện thị lên app
        }
      });
      // quản lý danh sách null
      this.$store.commit(
          "finance2Module/set_hidden_order_kids",
          this.listHiddenOrder
      );
      this.$store.commit(
          "finance2Module/set_show_for_app",
          this.listShowForApp
      );
      this.$store.commit(
          "finance2Module/set_hidden_for_app",
          this.listHiddenForApp
      );
      this.$store.commit(
          "finance2Module/set_null_bill_kids",
          this.listNullBillKids
      );
      // eslint-disable-next-line no-unused-vars
      let multipleSelectionCopy = this.multipleSelection;
      let idKidList = [];
      multipleSelectionCopy = multipleSelectionCopy.map((item) => {
        idKidList = [...idKidList, item.id];
      });
      this.$store.commit("finance2Module/set_id_kid_list", idKidList);
    },

    getStatusValue(status) {
      return status !== null ? status : "Chưa có hóa đơn";
    },

    getStatusColor(status) {
      if (status === null) {
        return "status-red";
      } else if (status === "Chưa đóng 100%" || status === "Chưa đóng đủ") {
        return "status-orange";
      } else if (status === "Đóng đủ 100%" || status === "Đóng thừa") {
        return "status-blue";
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-main {
  min-height: 950px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 210px;
  min-height: 700px;
  font-family: Arial, serif;
}

.router-link {
  text-decoration: none;
}

.el-menu-item {
  background-color: #1f2d3d !important;
}

.el-menu-item:hover {
  background-color: #49575f !important;
}

/deep/ .el-message-box {
  display: inline-block;
  vertical-align: top !important;
  width: 420px;
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/deep/ .el-message-box__wrapper::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: top !important;
}

.el-menu {
  margin-bottom: 20px;
}

.onekids-title {
  font-weight: bold;
}

/* Định nghĩa các lớp màu sắc */
.status-red {
  color: red;
}

.status-orange {
  color: orange;
}

.status-blue {
  color: blue;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 2px 0;
}

/deep/ .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #FFF;
}

span.el-tooltip {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

/deep/ .el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #F5F7FA;
  color: #0957f4;
}

/deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #F5F7FA;
  color: #0957f4;
}
</style>